import React from 'react';
import { connect } from 'react-redux';
import { getRequest, postRequest } from '../../../lib/apiUtils';
import AiIcon from '../../commonComponents/shared/AiIcon';

/**
 * Inline AI summary of the recipient's application history, shown above the
 * applications list on the recipient account page. Fetches the cached summary
 * and, when none is available yet, triggers generation. Renders nothing when
 * the AI summary is not configured or there is nothing to show.
 */
export class RecipientSummaryPanel extends React.Component {

    state = {
        summary: null,
        loading: false,
        error: false,
        aiLoading: false
    };

    requestId = 0;

    componentDidMount() {
        if (this.props.showAiSummaries) this.load();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.showAiSummaries && this.props.showAiSummaries) {
            this.load();
        } else if (prevProps.showAiSummaries && !this.props.showAiSummaries) {
            this.requestId++;
            this.setState({ loading: false, aiLoading: false });
        } else if (this.props.showAiSummaries && prevProps.recipientId !== this.props.recipientId) {
            this.load();
        }
    }

    componentWillUnmount() {
        this.requestId++;
    }

    load = async () => {
        const { recipientId } = this.props;
        if (!recipientId || !this.props.showAiSummaries) return;

        this.setState({ loading: true, error: false, summary: null, aiLoading: false });
        const requestId = ++this.requestId;

        const result = await getRequest(`/applications/recipients/${recipientId}/summary`);
        if (requestId !== this.requestId || !this.props.showAiSummaries) return;

        if (!result.success) {
            this.setState({ loading: false, error: true });
            return;
        }

        const pending = !!(result.data.aiSummaryPending && !result.data.aiSummary);
        this.setState({ summary: result.data, loading: false, aiLoading: pending });

        if (pending) this.generate();
    };

    generate = async () => {
        const { recipientId } = this.props;
        if (!this.props.showAiSummaries) return;
        const requestId = this.requestId;

        const result = await postRequest(`/applications/recipients/${recipientId}/summary/generate`);
        if (requestId !== this.requestId || !this.props.showAiSummaries) return;

        this.setState(prev => ({
            aiLoading: false,
            summary: {
                ...(prev.summary || {}),
                aiSummary: result.success ? result.data.aiSummary : null,
                aiSummaryGeneratedDate: result.success ? result.data.generatedDate : null,
                aiSummaryPending: !result.success
            }
        }));
    };

    renderShimmer = () => (
        <div aria-busy="true">
            <div className="shimmer-line" />
            <div className="shimmer-line" style={{ width: '80%' }} />
            <div className="shimmer-line" style={{ width: '55%' }} />
        </div>
    );

    render() {
        const { summary, loading, error, aiLoading } = this.state;

        if (!this.props.showAiSummaries || error) return null;

        const hasSummary = summary && summary.aiSummary;

        // Nothing to show: AI not configured, no visible applications, or no summary.
        if (!loading && !aiLoading && !hasSummary) return null;

        return (
            <div className="recipient-ai-summary-panel">
                <p className="panel-label">
                    <AiIcon className="ai-icon" size={15} />
                    AI Summary
                </p>
                {(loading || aiLoading)
                    ? this.renderShimmer()
                    : <p className="summary-text">{summary.aiSummary}</p>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        showAiSummaries: state.userProfile.profile.data.showAiSummaries !== false
    };
}

export default connect(mapStateToProps)(RecipientSummaryPanel);



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientSummaryPanel.jsx